import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useBackofficeAuth, type BackofficeRole } from '@/contexts/BackofficeAuthContext';

interface BackofficePrivateRouteProps {
  children: ReactNode;
  allowedRoles?: BackofficeRole[];
}

export default function BackofficePrivateRoute({ children, allowedRoles }: BackofficePrivateRouteProps) {
  const location = useLocation();
  const { isAuthenticated, canAccess } = useBackofficeAuth();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/backoffice/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  if (allowedRoles && !canAccess(allowedRoles)) {
    return (
      <Navigate
        to="/backoffice/dashboard"
        replace
      />
    );
  }

  return <>{children}</>;
}